export const sizes = {
  wide: '(max-width: 1600px)',
  xLarge: '(max-width: 1440px)',
  large: '(max-width: 1200px)',
  medium: '(max-width: 992px)',
  smallMedium: '(max-width: 640px)',
  small: '(max-width: 576px)',
  xSmall: '(max-width: 400px)',
};
